export default "__VITE_ASSET__eVQ7quQM__"